<template>
	<div class="result">
		<transition name="slide-fade">
			<div class="answer-wrap">
				<div class="answer-title">
					★結果D
					<div class="text">生活習慣・寝室環境以外に原因があるかも？</div>
				</div>
				<div class="answer-body">
					<p>睡眠の質UPには、生活習慣と睡眠環境（寝室や寝具）の両方を整えることが大切です。が、あなたの場合、それらはおおむね良好に保てているようです。それでも睡眠の質に不安がある場合、ストレスや病気といった要因が潜んでいるのかもしれません。</p>
					<div class="sub-cts"><h2>★改善へのアドバイス</h2>
						<p>さらに睡眠の質を上げるためには、「朝、日光浴をする」「日中、軽い運動をする」「3食きちんと、栄養バランスの良い食事を摂る」「通気性に優れた寝間着を選ぶ」といった工夫をすると良いでしょう。上記のような工夫をしても、なお「よく眠れない」「寝ても疲れがとれにくい」といった状況が続くのであれば、ストレスや病気（不眠障害、睡眠時無呼吸症候群など）が隠れている可能性があります。心身への負担を軽減するためにも、早めに医療機関（睡眠外来や心療内科など）を受診しましょう。</p>
					</div>
					<div class="sub-cts">
						<h2>▼こちらもCHECK</h2>
						<ul>
							<li><a href="https://xn--z8js3azm.com/science/16.html">睡眠障害とは？</a></li>
						</ul>
					</div>
				</div>
				<div class="btn-area">
					<button @click="next(0)" class="btnReset">スタートに戻る</button>
				</div>
			</div>
		</transition>
	</div>
</template>
<script>
export default {
	name: 'ResultCts04',
	methods: {
		next(page) {
			this.$store.dispatch('next', page)
		},
		onComplete: function () {
			this.btnFlg = true;
		}
	}
}
</script>